module.exports = __webpack_public_path__ + "templates.carousel-display-220a57e0.html";